import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import Error from '@/components/Error/Error';
import MenuHeader from '@/components/Header/MenuHeader';
import { ErrorCircleIcon } from '@/components/Icon';
import MyCarNumberInput from '@/components/Products/Sale/MyCarNumberInput';
// import MyListing from '@/components/Products/Sale/MyListing';
import OwnerNameInput from '@/components/Products/Sale/OwnerNameInput';
import { colors } from '@/const/colors/index';
import { SALESTYPE } from '@/const/products';
import useNavigateBack from '@/hooks/useNavigateBack';
import { useResetProductsForm } from '@/store/products';

interface ErrorInfo {
  licenseNumberError: boolean;
  licenseNumberErrorMessage: string;
  ownerNameError: boolean;
  ownerNameErrorMessage: string;
}

type SalesTypeKey = keyof typeof SALESTYPE;

const MyCarSaleDealer = () => {
  const navigateBack = useNavigateBack();
  const location = useLocation();
  const [salesType, setSalesType] = useState<String>();

  useEffect(() => {
    if (location.state?.type) {
      setSalesType(location.state?.type);
    }
  }, []);

  const [ownerInfo, setOwnerInfo] = useState<OwnerInfo>({
    licenseNumber: '',
    name: '',
  });

  const resetProductsForm = useResetProductsForm();
  const [errorInfo, setErrorInfo] = useState<ErrorInfo>();
  const [pageNum, setPageNum] = useState(1);

  const updatePage = (pageNum: number) => {
    setPageNum(pageNum);
  };
  const goPrev = () => {
    if (pageNum === 1) {
      navigateBack();
    } else {
      setPageNum((prev) => prev - 1);
    }
  };

  useEffect(() => {
    if (location.state?.pageNum) {
      updatePage(location.state.pageNum);
    }
  }, [pageNum]);

  useEffect(() => {
    resetProductsForm();
  }, []);

  return (
    <>
      <div className="flex flex-col justify-between w-full">
        <>
          <MenuHeader
            title={'내차판매'}
            onClickPrevBtn={() => {
              goPrev();
            }}
            // isMain={pageNum === 1}
          ></MenuHeader>
          <div>
            {pageNum === 1 && (
              <div className="pt-[60px] pb-20">
                <MyCarNumberInput
                  updatePage={updatePage}
                  ownerInfo={ownerInfo}
                  setOwnerInfo={setOwnerInfo}
                  errorInfo={errorInfo}
                  setErrorInfo={setErrorInfo}
                />
                {/* <div className="pb-16">
                  <MyListing />
                </div> */}
              </div>
            )}
            {pageNum === 2 && (
              <div className="pb-20">
                <OwnerNameInput
                  updatePage={updatePage}
                  ownerInfo={ownerInfo}
                  setOwnerInfo={setOwnerInfo}
                  errorInfo={errorInfo}
                  setErrorInfo={setErrorInfo}
                  salesType={salesType}
                />
              </div>
            )}
            {pageNum === 3 && (
              <div className="h-screen">
                <Error
                  icon={<ErrorCircleIcon color={colors.gray[5]} width={144} height={144}></ErrorCircleIcon>}
                  title="차량의 등록원부 조회 중<br/>오류가 발생했습니다"
                  description="서비스 정상화 후 자동으로<br/>차량 정보가 등록됩니다"
                ></Error>
              </div>
            )}
          </div>
        </>
      </div>
    </>
  );
};

export default MyCarSaleDealer;
